<template lang="pug">
.cp-cooperation
  .title 合作流程
  .subtitle 客户成功团队提供全生命周期伴随式服务
  ul.list.w
    li.item(v-for="(v, index) in list")
      img(:src="v.icon")
      .text
        span.num.fontA 0{{ index + 1 }}
        span.label {{ v.label }}
</template>
<script>
export default {
  components: {},
  props: {},
  data () {
    return {
      list: [
        { icon: require('@/assets/qianshu.png'), label: '签署合作协议' },
        { icon: require('@/assets/cailiao.png'), label: '提交商务接入材料' },
        { icon: require('@/assets/youhua.png'), label: '确认业务流程和优化方案' },
        { icon: require('@/assets/jiaofu.png'), label: '交付定制解决方案' },
        { icon: require('@/assets/bansui.png'), label: '伴随式服务' },
      ]
    }
  },
  computed: {},
  methods: {}
}
</script>
<style lang="stylus">
.cp-cooperation
  padding-top 170px
  margin-bottom 282px
  .list
    display flex
    justify-content space-between
    align-items center
    margin-top 162px
    padding 0px 50px
    .item
      position relative
      width 120px
      height 120px
      background rgba(37,70,112,0.66)
      border 2px solid #5384C1
      border-radius 50%
      display flex
      justify-content center
      align-items center
      img
        width 60px
      .text
        position absolute
        top 140px
        left -50px
        width 190px
        text-align center
        .fontA
          font-size 30px
          font-weight bold
          color rgba(158,234,250,1)
        .label
          display inline-block
          vertical-align top
          margin-top 8px
          margin-left 6px
          font-size 20px
          text-align center
      &:nth-child(2)
        &::before
          content ''
          display block
          width 141px
          height 15px
          background url('../../../assets/dash-arc.png') center / 100% no-repeat
          position absolute
          left -135px
          top 10px
        &::after
          content ''
          display block
          width 141px
          height 15px
          background url('../../../assets/dash-arc.png') center / 100% no-repeat
          transform rotate(180deg)
          position absolute
          left 110px
          top 90px
        .text
          top -100px
          .label
            width 85px
      &:nth-child(3)
        .label
          width 140px
      &:nth-child(4)
        &::before
          content ''
          display block
          width 141px
          height 15px
          background url('../../../assets/dash-arc.png') center / 100% no-repeat
          position absolute
          left -135px
          top 10px
        &::after
          content ''
          display block
          width 141px
          height 15px
          background url('../../../assets/dash-arc.png') center / 100% no-repeat
          transform rotate(180deg)
          position absolute
          left 110px
          top 90px
        .text
          top -100px
          .label
            width 120px
</style>
